export default "__VITE_ASSET__99e80d7a__"